import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

export const getExploreAPI = (params = {}, signal) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/gallery/explore", {
        params,
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        signal,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        if (err?.name === "CanceledError" || err?.code === "ERR_CANCELED") {
          return reject(err);
        }
        console.error("getExploreAPI error:", err);
        reject(err?.response?.data || err);
      });
  });
};

export const getMyFeedAPI = (params = {}, signal) => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/gallery/my-feed", {
        params,
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        signal,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err?.response?.data || err);
      });
  });
};
